/** Custom header every request carries; the server refuses a mutation under /api without it. */
export const CSRF_HEADER = 'X-Codex-Request';
/** The only value the server accepts for {@link CSRF_HEADER}. */
export const CSRF_HEADER_VALUE = '1';
/** Name of the httpOnly session cookie. */
export const SESSION_COOKIE = 'codex_session';
export const HTTP_METHODS = ['GET', 'POST', 'PUT', 'PATCH', 'DELETE'];
/**
 * The response header a route marked `changeBatch` answers on every success (CS r5b deliverable
 * 162; DECISIONS 212 item 5): the id of the `change_batch` row the write opened, whose
 * `change_log` rows are exactly that write's. 2.L's toast offers Undo of it.
 */
export const CHANGE_BATCH_HEADER = 'x-codex-change-batch';
//# sourceMappingURL=http.js.map